
<template>
  <v-btn-group v-if="!isStarted" dense>
    <v-btn color="error" @click="emitEvent('exit')">Exit</v-btn>
    <v-btn color="primary" @click="emitEvent('start')">Start</v-btn>
  </v-btn-group>
  <v-btn color="info" v-else @click="emitEvent('next')">Next</v-btn>
</template>

<script>
export default {
  data: () => ({
    isStarted: false
  }),
  methods: {
    emitEvent(action) {
      if (action === 'start') {
        this.isStarted = true;
      }
      this.$emit(action);
    }
  }
}
</script>
<style scoped>
.navigation-control {
  display: flex;
  justify-content: space-between;
}
</style>


